<template>
  <div class="main">
    <h1>Регистрация</h1>

    <div class="field-form">
      <p v-if="message">{{ message }}</p>

      <div class="field-wrapper" v-if="!sendVerify">
        <input
          v-model="email"
          @input="formatEmail"
          ref="inputEmail"
          type="email"
          placeholder="&nbsp;"
          spellcheck="false"
          autocomplete="off"
        />
        <label>Email</label>
      </div>

      <vue-recaptcha
        v-if="!sendVerify"
        ref="recaptcha"
        @verify="onVerify"
        @expired="onExpired"
        sitekey="6Lf94DMeAAAAAERMa4Dxk3SCK6bYjXQ53gD2JxiS"
      ></vue-recaptcha>

      <div class="field-wrapper" v-if="sendVerify">
        <input
          v-model="verifyCode"
          @input="formatVerifyCode"
          ref="inputVerify"
          type="tel"
          maxlength="4"
          placeholder="&nbsp;"
          spellcheck="false"
          autocomplete="off"
        />
        <label>Код подтверждения</label>
      </div>
      <button
        v-if="!sendVerify"
        :disabled="loadingReg || !email || !recaptchaResponse"
        @click="reg"
        type="submit"
      >
        Создать аккаунт
      </button>
      <button
        v-if="sendVerify"
        :disabled="loadingVerify || !verifyCode"
        @click="verify"
        type="submit"
      >
        Подтвердить
      </button>
    </div>

    <div style="display: flex; gap: 10px">
      <button
        @click="this.$router.push('/login')"
        style="
          display: flex;
          border: none;
          padding: 5px 10px;
          border-radius: 5px;
          cursor: pointer;
          font-size: inherit;
          font-family: inherit;
          box-shadow: rgb(189, 186, 186) 0px 5px 20px -6px;
          transition: all 0.2s ease-in 0s;
          background: #333;
          color: white;
          letter-spacing: inherit;
        "
      >
        Авторизация
      </button>
    </div>
  </div>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
export default {
  components: { VueRecaptcha },
  data() {
    return {
      email: '',
      verifyCode: '',
      sendVerify: false,
      loadingReg: false,
      loadingVerify: false,
      message: '',
      recaptchaResponse: null,
    };
  },

  methods: {
    async reg() {
      this.loadingReg = true;
      const email = this.email;
      const checkerPartner = localStorage.checkerPartner ?? false;

      try {
        const response = await this.$store.dispatch('register', {
          email,
          checkerPartner,
          recaptchaResponse: this.recaptchaResponse,
        });

        if (response.data.ok) {
          this.sendVerify = true;

          delete localStorage.checkerPartner;

          this.message = response.data.message;

          this.$nextTick(() => {
            this.$refs.inputVerify.focus();
          });
        } else {
          this.resetRecaptcha();
          this.showToaster(response.data.message);
        }

        this.loadingReg = false;
      } catch (err) {
        console.log(err);
        this.showToaster('Неизвесная ошибка. Попробуйте еще раз');
      }
    },

    async verify() {
      this.loadingVerify = true;
      const email = this.email;
      const code = this.verifyCode;

      try {
        const response = await this.$store.dispatch('verify', { email, code });

        if (response.data.success) {
          this.$router.push('/');
        } else {
          this.showToaster(response.data.message);
        }

        this.loadingVerify = false;
      } catch (err) {
        console.log(err);
        this.showToaster('Неизвесная ошибка. Попробуйте еще раз');
      }
    },

    showToaster(msg) {
      this.$toast.show(msg, {
        position: 'top',
        // duration: false,
      });
    },

    formatVerifyCode() {
      this.verifyCode = this.verifyCode.replace(/[^\d]/g, '');
    },

    formatEmail() {
      this.email = this.email.replace(/[^a-zA-Z0-9-_+@.]/g, '');
    },

    onVerify(response) {
      this.recaptchaResponse = response;
      this.showToaster('Спасибо, что не робот :)');
    },
    onExpired() {
      this.recaptchaResponse = null;
    },
    resetRecaptcha() {
      this.recaptchaResponse = null;
      this.$refs.recaptcha.reset();
    },
  },

  mounted() {
    // this.$refs.inputEmail.focus();
    this.$router.push('/login');

  },
};
</script>

<style scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;
  min-height: calc(100vh - 46px);
  padding: 15px;
}

.field-wrapper .login {
  color: #333333;
  border: 2px solid grey;
  border-radius: 5px;
  box-shadow: rgb(189 186 186) 0px 0px 20px -6px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 350px;
}

.login > h1 {
  margin: 0 0 20px 0;
  text-align: center;
}

.login > input {
  padding: 10px;
  border: 2px solid grey;
  border-radius: 5px;
  outline: 0;
  margin: 0 0 10px 0;
  font-size: 16px;
}

.login > button {
  cursor: pointer;
  padding: 12px;
  border: 0;
  border-radius: 5px;
  text-transform: uppercase;
  font-family: inherit;
  font-size: 16px;
  background: #186d04;
  color: white;
}

.login > p {
  margin: 10px 0 0 0;
  font-size: 14px;
}
</style>